module.exports = __webpack_public_path__ + "img/caret-down-alt.719016b5.svg";